module.exports = __webpack_public_path__ + "img/kk.23430419.svg";